//Save Permission
const initialState = {
  isFetching: null,
  isError: false,
  result: { content: { data: []}, status: true },
};

export const SETTING_PERMISSION_MANAGE_FETCHING =
  'SETTING_PERMISSION_MANAGE_FETCHING';
export const SETTING_PERMISSION_MANAGE_FAILED =
  'SETTING_PERMISSION_MANAGE_FAILED';
export const SETTING_PERMISSION_MANAGE_SUCCESS =
  'SETTING_PERMISSION_MANAGE_SUCCESS';
export const SettingPermissionManageReducer = (
  state = initialState,
  { type, payload }
) => {
  switch (type) {
    case SETTING_PERMISSION_MANAGE_FETCHING:
      return { ...state, isFetching: true, isError: false };
    case SETTING_PERMISSION_MANAGE_FAILED:
      return {
        ...state,
        isFetching: false,
        isError: true,
        result: { content: { data: []} },
      };
    case SETTING_PERMISSION_MANAGE_SUCCESS:
      return { ...state, isFetching: false, isError: false, result: payload };
    default:
      return state;
  }
};

export const SETTING_PERMISSION_MANAGE_SAVE_FETCHING =
  'SETTING_PERMISSION_MANAGE_SAVE_FETCHING';
export const SETTING_PERMISSION_MANAGE_SAVE_FAILED =
  'SETTING_PERMISSION_MANAGE_SAVE_FAILED';
export const SETTING_PERMISSION_MANAGE_SAVE_SUCCESS =
  'SETTING_PERMISSION_MANAGE_SAVE_SUCCESS';
export const SettingPermissionManageSaveReducer = (
  state = initialState,
  { type, payload }
) => {
  switch (type) {
    case SETTING_PERMISSION_MANAGE_SAVE_FETCHING:
      return { ...state, isFetching: true, isError: false };
    case SETTING_PERMISSION_MANAGE_SAVE_FAILED:
      return {
        ...state,
        isFetching: false,
        isError: true,
        result: { content: { data: []} },
      };
    case SETTING_PERMISSION_MANAGE_SAVE_SUCCESS:
      return { ...state, isFetching: false, isError: false, result: payload };
    default:
      return state;
  }
};
//Edit permission
export const SETTING_PERMISSION_MANAGE_EDIT_FETCHING =
  'SETTING_PERMISSION_MANAGE_EDIT_FETCHING';
export const SETTING_PERMISSION_MANAGE_EDIT_FAILED =
  'SETTING_PERMISSION_MANAGE_EDIT_FAILED';
export const SETTING_PERMISSION_MANAGE_EDIT_SUCCESS =
  'SETTING_PERMISSION_MANAGE_EDIT_SUCCESS';
export const SettingPermissionManageEditReducer = (
  state = initialState,
  { type, payload }
) => {
  switch (type) {
    case SETTING_PERMISSION_MANAGE_EDIT_FETCHING:
      return { ...state, isFetching: true, isError: false };
    case SETTING_PERMISSION_MANAGE_EDIT_FAILED:
      return {
        ...state,
        isFetching: false,
        isError: true,
        result: { content: { data: []} },
      };
    case SETTING_PERMISSION_MANAGE_EDIT_SUCCESS:
      return { ...state, isFetching: false, isError: false, result: payload };
    default:
      return state;
  }
};
//Select By Id
export const SETTING_PERMISSION_MANAGE_BY_ID_FETCHING =
  'SETTING_PERMISSION_MANAGE_BY_ID_FETCHING';
export const SETTING_PERMISSION_MANAGE_BY_ID_FAILED =
  'SETTING_PERMISSION_MANAGE_BY_ID_FAILED';
export const SETTING_PERMISSION_MANAGE_BY_ID_SUCCESS =
  'SETTING_PERMISSION_MANAGE_BY_ID_SUCCESS';
export const SettingPermissionManageByIdReducer = (
  state = initialState,
  { type, payload }
) => {
  switch (type) {
    case SETTING_PERMISSION_MANAGE_BY_ID_FETCHING:
      return { ...state, isFetching: true, isError: false };
    case SETTING_PERMISSION_MANAGE_BY_ID_FAILED:
      return {
        ...state,
        isFetching: false,
        isError: true,
        result: { content: { data: []} },
      };
    case SETTING_PERMISSION_MANAGE_BY_ID_SUCCESS:
      return { ...state, isFetching: false, isError: false, result: payload };
    default:
      return state;
  }
};
